import React from 'react'
import TimesLogoGerman from '../images/123erfasst-logo.svg';
import TimesLogo from '../images/123onsite-logo.svg'
import QualityLogo from '../images/123quality-logo.svg';
import FleetLogo from '../images/123fleet_Logo_rgb.svg'
import { useBrowserLanguage, BrowserLanguage } from "../locale/browserLanguageHook"

export type Logos = 'quality' | 'erfasst' | 'fleet'

interface Props {
    logo: Logos
}

const getLogo = (logo: Logos) => {
    const lang = useBrowserLanguage()
    switch (logo) {
        case 'quality':
            return QualityLogo
        case 'erfasst':
            return lang === BrowserLanguage.German ? TimesLogoGerman : TimesLogo
        case 'fleet':
            return FleetLogo
    }
}

export default ({ logo }: Props) => <img height="50" src={getLogo(logo)} />